export const handleRedirectCallbackUrl = (url: string) => {
  if (url === 'induction_hub') {
    return `${process.env.MYTHIC_INDUCTION_HUB_V2}`;
  } else if (url === 'dum') {
    return `${process.env.MYTHIC_DUM_URL}`;
  } else {
    return '';
  }
};
